<script>
export default {
    data() {
        return {
            active: 1
        };
    }
};
</script>

<style lang="scss" scoped>
.embed-container iframe,
.embed-container object {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
</style>
